<template>
  <base-dialog v-model="visible" width="520px" class="publish-confirm-dialog" append-to-body type="warning" title="商城发布">
    <div class="publish-confirm-dialog__content">
      <div class="my-6 text-center text-white text-16">确认发布吗？</div>
      <div class="flex items-center justify-end py-4 px-5 gap-5">
        <button class="normal-btn" @click.stop="handleCancel">取 消</button>
        <button class="delete-btn" :class="{ 'opacity-70': loading }" @click.stop="handleSave">
          <i v-if="loading" class="el-icon-loading"></i>
          发 布
        </button>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from '~/components/base/baseDialog.vue'
export default {
  name: 'PublishConfirmDialog',
  components: { BaseDialog },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    init() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    handleSave() {
      this.$emit('publish')
      this.handleCancel()
    },
  },
}
</script>

<style lang="less">
.publish-confirm-dialog {
  &__content {
    .normal-btn {
      background-color: white;
      line-height: 36px;
      padding: 0 20px;
      color: black;
      border: 1px solid #dedede;
      border-radius: 6px;
    }
    .delete-btn {
      background-color: @primary-1;
      line-height: 36px;
      padding: 0 20px;
      color: white;
      border: 1px solid @primary-1;
      border-radius: 6px;
    }
  }
}
</style>
